
import sonidoSOS from "../assets/google_emergency_sos.mp3";


let audio = null;
let sonidoDesbloqueado = false;
let repeticionesPendientes = 0;
let preparado = false;
let intervaloParpadeo = null;
let textoParpadeo = "";
let tituloReal = null;


const hayVentana = () => typeof window !== "undefined";

const hayNotificaciones = () => hayVentana() && "Notification" in window;

export const permisoNotificaciones = () => {
  if (!hayNotificaciones()) return "no-soportado";
  try {
    return Notification.permission;
  } catch {
    return "no-soportado";
  }
};


const crearAudio = () => {
  if (audio || !hayVentana()) return audio;
  try {
    audio = new Audio(sonidoSOS);
    audio.preload = "auto";

    audio.addEventListener("ended", () => {
      if (repeticionesPendientes > 0) {
        repeticionesPendientes -= 1;
        intentarReproducir();
      }
    });
  } catch (error) {
    console.warn("No se pudo preparar el audio de SOS:", error);
    audio = null;
  }
  return audio;
};

const intentarReproducir = () => {
  const pista = crearAudio();
  if (!pista) return;

  try {
    pista.currentTime = 0;
    const promesa = pista.play();

    if (promesa && typeof promesa.catch === "function") {
      promesa
        .then(() => { sonidoDesbloqueado = true; })
        .catch(() => {
          sonidoDesbloqueado = false;
          armarDesbloqueo();
        });
    }
  } catch {
    sonidoDesbloqueado = false;
    armarDesbloqueo();
  }
};

const desbloquearSonido = () => {
  const pista = crearAudio();
  if (!pista || sonidoDesbloqueado) return;

  try {
    const volumenPrevio = pista.volume;
    pista.volume = 0;
    const promesa = pista.play();

    const restaurar = () => {
      try {
        pista.pause();
        pista.currentTime = 0;
        pista.volume = volumenPrevio;
      } catch {  }
    };

    if (promesa && typeof promesa.then === "function") {
      promesa.then(() => { sonidoDesbloqueado = true; restaurar(); }).catch(restaurar);
    } else {
      sonidoDesbloqueado = true;
      restaurar();
    }
  } catch {  }
};

let desbloqueoArmado = false;

const armarDesbloqueo = () => {
  if (desbloqueoArmado || !hayVentana()) return;
  desbloqueoArmado = true;

  const alInteractuar = () => {
    desbloqueoArmado = false;
    quitar();
    desbloquearSonido();
  };

  const eventos = ["pointerdown", "keydown", "touchstart"];
  const quitar = () =>
    eventos.forEach((evento) => window.removeEventListener(evento, alInteractuar));

  eventos.forEach((evento) =>
    window.addEventListener(evento, alInteractuar, { once: true, passive: true })
  );
};

const CLAVE_ULTIMO_SONIDO = "sos_ultimo_sonido";
const MS_ANTIRREBOTE_SONIDO = 3000;

const otraPestanaYaSono = () => {
  try {
    const ahora = Date.now();
    const previo = Number(localStorage.getItem(CLAVE_ULTIMO_SONIDO)) || 0;

    if (ahora - previo < MS_ANTIRREBOTE_SONIDO) return true;

    localStorage.setItem(CLAVE_ULTIMO_SONIDO, String(ahora));
    return false;
  } catch {
    return false;
  }
};

export const sonarAlerta = (veces = 1) => {
  if (otraPestanaYaSono()) return false;

  repeticionesPendientes = Math.max(0, veces - 1);
  intentarReproducir();
  return true;
};

export const detenerSonido = () => {
  repeticionesPendientes = 0;
  if (!audio) return;
  try {
    audio.pause();
    audio.currentTime = 0;
  } catch {  }
};


export const notificar = ({ titulo, cuerpo, alHacerClic }) => {
  if (permisoNotificaciones() !== "granted") return false;

  try {
    const notificacion = new Notification(titulo, {
      body: cuerpo,
      tag: "coordiph-sos",
      renotify: true,
      requireInteraction: true,
    });

    notificacion.onclick = () => {
      try {
        window.focus();
        alHacerClic?.();
        notificacion.close();
      } catch {  }
    };

    return true;
  } catch (error) {
    console.warn("No se pudo mostrar la notificación de SOS:", error);
    return false;
  }
};

export const pedirPermisoNotificaciones = async () => {
  if (!hayNotificaciones()) return "no-soportado";
  try {
    if (Notification.permission !== "default") return Notification.permission;
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
};


export const iniciarParpadeoTitulo = (texto) => {
  if (typeof document === "undefined") return;
  if (intervaloParpadeo && textoParpadeo === texto) return;

  detenerParpadeoTitulo();
  textoParpadeo = texto;

  let mostrandoAlerta = false;

  intervaloParpadeo = setInterval(() => {
    try {
      if (document.title !== textoParpadeo) tituloReal = document.title;

      document.title = mostrandoAlerta ? (tituloReal || "CoordiPH") : textoParpadeo;
      mostrandoAlerta = !mostrandoAlerta;
    } catch {  }
  }, 1200);
};

export const detenerParpadeoTitulo = () => {
  if (intervaloParpadeo) {
    clearInterval(intervaloParpadeo);
    intervaloParpadeo = null;
  }
  if (typeof document === "undefined") return;

  try {
    if (tituloReal && document.title === textoParpadeo) document.title = tituloReal;
  } catch {  }

  textoParpadeo = "";
};


export const prepararAlertas = () => {
  if (preparado) return;
  preparado = true;

  crearAudio();
  armarDesbloqueo();

  pedirPermisoNotificaciones();

  if (hayVentana()) {
    window.addEventListener(
      "pointerdown",
      () => { pedirPermisoNotificaciones(); },
      { once: true, passive: true }
    );
  }
};

export const estadoAlertas = () => ({
  sonidoDesbloqueado,
  permiso: permisoNotificaciones(),
});
